// extracted by mini-css-extract-plugin
export default {"tip":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelRegistration-CustomerDatabase-css-module__tip--cmCWf"};